// extracted by mini-css-extract-plugin
export default {"value":"styles_value__WoKhc"};